import axios from "axios";
import AlertModule from 'vux/src/plugins/alert/module'

import { SERVER, LOGIN_OUT, TIME_OUT } from "../config";
import { getToken, getAgent, clearLocalStorage } from "../utils";

const service = axios.create({
baseURL: SERVER,
timeout: TIME_OUT,
validateStatus: (status) => {
return status >= 200 && status < 500;
},
});

service.interceptors.request.use(
(config) => {
if (!config.url) {
return Promise.reject("无效的请求地址");
}
config.headers.Token = getToken();
config.headers["Accept-Agent"] = getAgent();
layer.open({
type: 2,
shadeClose: false,
});
return config;
},
(error) => {
return Promise.reject(error);
}
);

service.interceptors.response.use(
(res) => handleResult(res),
async (error) => {
layer.open({
content: `${error}`,
skin: "msg",
time: 2, //2秒后自动关闭
});
await setTimeout(() => {
layer.closeAll();
}, 2000);
return Promise.reject(error);
}
);

const handleResult = async (result) => {
layer.closeAll();
if (result.status === 200 && result.data.statusCode === "200") {
return Promise.resolve(result.data.content);
} else if (result.status === 200 && result.data.statusCode === "301") {
layer.open({
content: result.data.information,
skin: "msg",
time: 2, //2秒后自动关闭
});
return Promise.reject(result);
} else if (result.status === 401) {
await clearLocalStorage();
layer.open({
content: "登录超时，请重新登录~",
skin: "msg",
time: 2, //2秒后自动关闭
});
window.location.href = LOGIN_OUT;
window.location.reload();
return Promise.reject(result);
} else if (result.status === 500) {
layer.open({
content: result.error,
skin: "msg",
time: 2, //2秒后自动关闭
});
return Promise.reject(result);
} else {
AlertModule.show({
title: "操作提示",
content: `${result.data.information}`,
hideOnBlur: true,
dialogTransition: "rotateIn",
});
return Promise.reject(result);
}
};

export default service;



// WEBPACK FOOTER //
// ./src/http/handleRequest.js